import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Paragraph, Button, /*Layer,*/ TextInput } from 'grommet';
import Header from '../Components/Header';
import HeaderLogout from '../Components/HeaderLogout';
import Footer from '../Components/Footer';
import { StatusInfo } from 'grommet-icons';

class Error extends React.Component {

    render() {

        return (
            <Box>
                {this.props.testo.length > 0 ? <Text className='error'>{this.props.testo}</Text> : <div className='margin-error'></div>}
            </Box>
        );
    }
}

class InsertTelephoneStep1 extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props)
        this.state = {
            modalMessage: false,
            next: this.props.values.dataSendNum
        }

    }
    componentWillReceiveProps(newProps) {
        if (newProps !== newProps.values.dataSendNum)
            this.setState({
                next: newProps
            })
    }

    saveAndContinue = () => {
        this.props.sendCellNumber();
        if (this.state.next) {
            this.props.nextStep();
        }
    }

    back = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }

    render() {
        return (
            <Box>
                {window.location.pathname !== '/InsertTelephone' ? <Header /> : <HeaderLogout />}
                <Box style={{ height: '81px' }}></Box>
                <Box align='center' className='content content-pre-login' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>
                    <Box className='contentbox'>
                        <Box direction="column" align='center'>
                            <Box direction='row' >
                                <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>Inserisci il numero di telefono cellulare</h1>
                                <Text className='titlehome' style={{ marginBottom: '5px' }}></Text>
                            </Box>
                            <Box style={{ height: '280px', marginTop: '70px' }}>
                                <Box direction='row' justify='center'>
                                    <Paragraph className='textParagraph'>Per garantire <span className='bold'>la tua sicurezza</span> abbiamo bisogno del tuo <span className='bold'>numero di cellulare</span></Paragraph>
                                </Box>
                                <Box direction='column' margin='small' style={{ margin: '50px 50px 0' }}>
                                    <Text className='label'>NUMERO DI TELEFONO CELLULARE</Text>
                                    <div style={{ display:'inline-flex', width: '300px' }}>
                                        <Box direction='row'>
                                            {/*<Text style={{ margin: '8px 30px 0 0', fontFamily: 'Segoe UI Semibold', fontSize: '15px' }}>+39</Text>*/}<TextInput id='otp' size='medium' className='inputFormdisp inputNumberNoArrow' style={{ width: '100%' }} onChange={this.props.setTelephone} maxLength={15}  value={this.props.values.telephone} />
                                            <div class="tooltipPwd"><StatusInfo className="iconTooltip" aria-label="Informazioni sul numero di telefono"/>
                                                <span class="tooltiptext">
                                                Indicare sempre il prefisso internazionale. Es: +39 per l'Italia
                                                </span>
                                            </div>
                                        </Box>
                                    </div>
                                </Box>
                                <Error testo={this.props.values.msgError} />
                            </Box>
                            <Box className='informativa' justify='center' direction='row'>
                                <Button className='btnform' style={{ width: '170px', margin: '0 30px 0 0' }} onClick={this.back}>INDIETRO</Button>
                                <Button className={this.state.buttonState ? 'btnform disabled' : 'btnform'} style={{ width: '170px' }} disabled={this.props.values.buttonState} onClick={this.saveAndContinue}>AVANTI</Button>
                            </Box>
                        </Box>
                    </Box>

                </Box>

                <Footer />
            </Box >
        )
    }
}

export default InsertTelephoneStep1;
